import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import Image from "next/image";
import DynamicSizeIcon from "../DynamicSizeIcon";
import { ReactNode } from "react";
import { useGlobalData } from "@/contexts/GlobalData";
import DynamicFontSize from "../DynamicFontSize";
interface ValueGroupPropsType extends GeneralPropsType {
  field?: ReactNode;
  value?: ReactNode;
  des?: string;
  icon?: string;
  hideIcon?: boolean;
  onClickIcon?: (data?: any) => any;
  iconValue?: string;
  overrideValueClass?: string;
  overrideFieldClass?: string;
  overrideDesClass?: string;
  unit?: string;
  overrideIcon?: ReactNode;
  overrideValueStyle?: Record<string, string>;
  titleChild?: ReactNode;
}
function ValueGroup({
  field,
  value,
  des,
  children,
  iconValue,
  icon,
  hideIcon,
  onClickIcon,
  className,
  overrideValueClass,
  overrideFieldClass,
  overrideDesClass,
  overrideIcon,
  unit,
  overrideValueStyle,
  titleChild,
  onClick
}: ValueGroupPropsType) {
  const {
    getIcon
  } = useGlobalData();
  return <div className={clsx("flex flex-col gap-1", styles.container, className)} onClick={onClick} data-sentry-component="ValueGroup" data-sentry-source-file="index.tsx">
            <div className="flex items-center gap-2">
                <div className="flex items-center flex-1 gap-1">
                    <DynamicFontSize fontSize={14} className={clsx(styles.field, overrideFieldClass)} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                        {field}
                    </DynamicFontSize>
                    {!!titleChild && <span className="mr-auto">{titleChild}</span>}
                </div>
                {!hideIcon && <div onClick={onClickIcon} className="ml-auto p-1 pr-0">
                        <DynamicSizeIcon icon={getIcon("forward_primary")} width={11} height={11} />
                    </div>}
            </div>
            {des && <div className={clsx(styles.des, overrideDesClass)}>{des}</div>}
            {value && <div className="flex items-center gap-2 justify-between">
                    <DynamicFontSize fontSize={15} className={clsx(styles.value, overrideValueClass)} style={overrideValueStyle}>
                        {value} {unit && <span className="text-current opacity-[0.42] font-[400] flex-1">{unit}</span>}
                    </DynamicFontSize>
                    {iconValue && !overrideIcon && <DynamicSizeIcon icon={iconValue} width={16} />}
                    {overrideIcon}
                </div>}
            {children}
        </div>;
}
export default ValueGroup;